<div class="header-container">
    <a
        class="logo"
        href="#"
        (click)="navigateHome()">
        <img
            [src]="logo"
            alt="" />
    </a>
</div>

<div class="header-container">
    <ng-content select="kno2-topnav"></ng-content>
    <div
        class="control-item user-menu"
        role="button"
        tabindex="0"
        (click)="menu.toggle($event)"
        (keydown.enter)="menu.toggle($event)"
        (keydown.space)="menu.toggle($event); $event.preventDefault()">
        <kno2-avatar
            [image]="user?.picture"
            [label]="userInitials" />
        <span class="user-name ml-2">{{ user?.name }}</span>
    </div>
    <kno2-menu
        #menu
        [model]="dropdownItems" />
</div>
